module.exports = __webpack_public_path__ + "img/img_logo_v2.8fe720af.png";